import React from "react";
import { Handle, Position } from "reactflow";
import { StageNodeData } from "../helpers/workflow.types";

/* ----------------------------------
   Types
---------------------------------- */

interface StageNodeProps {
  data: StageNodeData;
}

/* ----------------------------------
   Component
---------------------------------- */

const StageNode: React.FC<StageNodeProps> = ({ data }) => {
  const { stage, onEdit, onDelete, readOnly, index } = data;

  const roles = Array.isArray(stage.roles)
    ? stage.roles
    : stage.role
      ? [stage.role]
      : [];

  return (
    <div
      style={{
        padding: 10,
        borderRadius: 6,
        border: "1px solid #0d6efd",
        background: "#ffffff",
        minWidth: 180,
      }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-1" style={{ gap: "8px" }}>
        <strong>
          <span
            title={stage.stageName && stage.stageName.length > 12 ? stage.stageName : undefined}
            style={{
              maxWidth: "110px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "inline-block",
              verticalAlign: "bottom",
            }}
          >
            {stage.stageName}
          </span>
        </strong>

        {!readOnly && index > 0 && (
          <div>
            <i
              className="ri-pencil-line me-2"
              style={{ cursor: "pointer" }}
              onClick={() => onEdit(stage)}
            />
            {stage.stageId !== 1 && (
              <i
                className="ri-delete-bin-line text-danger"
                style={{ cursor: "pointer" }}
                onClick={() => onDelete(stage)}
              />
            )}
          </div>
        )}
      </div>

      {/* Roles */}
      <div className="d-flex flex-wrap gap-1">
        {stage?.role ? (
          <span key={stage.role} className="badge bg-secondary">
            {stage.roleName}
          </span>
        ) : (
          <span className="text-muted small">No Roles</span>
        )}
      </div>

      {/* Handles */}
      <Handle type="target" position={Position.Top} />
      <Handle type="source" position={Position.Bottom} />

      <Handle type="source" position={Position.Left} id="return-left-src" />
      <Handle type="target" position={Position.Left} id="return-left-tgt" />

      <Handle type="source" position={Position.Right} id="return-right-src" />
      <Handle type="target" position={Position.Right} id="return-right-tgt" />
    </div>
  );
};

export default StageNode;
